const Index = {
  white: '#fff',
  black: '#000',
  chokuBlack: '#333',
  chokuRed: '#FF3000',
  chokuGray: '#818181',
  chokuGray2: '#555555',
  chokuGray3: '#ACACAC',
  chokuGray4: '#DCDCE0',
  chokuGray5: '#979797',
  chokuGray6: '#B6B6B6',
  chokuGray7: '#EEEEEE',
  chokuGray8: '#B2B2B2',
  chokuGray9: '#7B7B7B',
  chokyGray10: '#7A7A7A',
  chokuGray11: '#FAFAFA',
  chokuGray12: '#F6F6F6',
  chokuGreen: '#0ADFDD',
  gray1: '#EFEFEF',
  orange: 'orange',
};

export default Index;
